/** @jsx jsx */

import React, {
  Fragment as _,
  memo,
  useMemo,
  createContext,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Matching from './Matching_v2';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import EditableBtn from 'components/lib/EditableBtn';
import Image from 'components/lib/Image';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { imgPlaceholders } from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import getMediaParent from 'services/apiHelpers/getMediaParent';
import MatchDrag from './MatchDrag';
import MatchDrop from './MatchDrop';
import shouldUpdate from 'services/shouldUpdate';
import imagePlaceholder from 'assets/Square.png';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { ImageContext } from 'components/lib/Image';

const SingleColumnLayout = Row.bind({}) as any;

SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: ({ children, ...props }) => (
    <EditableText {...{ ...props, className: 'matching-text' }} />
  ),
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Image: ({ children, ...props }) => {
    const mediaParent = getMediaParent(props.id);

    //
    return mediaParent ? (
      <Image
        {...{
          ...props,
          placeholder: imgPlaceholders[1],
        }}
      />
    ) : (
      <Image {...props} />
    );
  },
  Video,
  Audio,
  SVG,
  Embed,
  Media,
  PDF,
  OpenPDF,
  Transcript,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [matching, txt] = children;

    if (!includeAdditionalTextField) {
      return matching;
    }

    return (
      <_>
        {matching}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },

  MatchPairs: ({ children, ...props }) => children,
  Matching({ children, ...props }) {
    return (
      <ImageContext.Provider
        value={{
          editWrapperType: 1,
          placeholder: imagePlaceholder,

          //
          canUpdateContainerHeight: false,
        }}
      >
        <Matching {...props}>{children}</Matching>
      </ImageContext.Provider>
    );
  },
  MatchDrag,
  MatchDrop,
  DragContainer: ({ children, ...props }) => children,
  DropContainer: ({ children, ...props }) => children,
  AnswerContainer: ({ children, ...props }) => null,
  Answer: () => null,
  Feedback: ({ children, ...props }) => children,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Modal: () => null,
  ModalWithEditableBtn: () => null,
};

const MatchingDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default MatchingDisplay;
